<small *ngIf="isLoading" class="loaderFile">
  <img src="/assets/images/preloader.gif" style="height: 18px;width: auto; display: inline-block; margin-bottom: -3px;" />
  {{ loadingText }}
</small>
